/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     */
    message_id: string;
    /**
     * 
     */
    referral_id: string;
    /**
     * Which side of the thread wrote this. Replaces `message_type`, which could not tell the two human sides apart.
     */
    author_type: MessageAuthorTypeEnum;
    /**
     * The authoring recipient's `Recipient.participant_id`. Non-null exactly when `author_type` is `referral_participant`.
     */
    author_participant_id?: string | null;
    /**
     * Numeric `users.id` of the author. Always numeric, unlike `sender_user_id`. Null for system messages, for magic-link authors, who have no `users` row, and for messages written before this field existed.
     */
    author_user_id?: string | null;
    /**
     * Deprecated — use `author_type`.
     * @deprecated
     */
    message_type: MessageMessageTypeEnum;
    /**
     * Deprecated — use `author_user_id`. Holds an Auth0 subject, a numeric `users.id` or null depending on how the message was created.
     * @deprecated
     */
    sender_user_id: string | null;
    /**
     * 
     */
    sender_user_name?: string | null;
    /**
     * 
     */
    sender_user_title?: string | null;
    /**
     * Deprecated — use `author_type` and `author_participant_id`. Carries a synthetic value for external recipients.
     * @deprecated
     */
    sender_facility_id: string;
    /**
     * Deprecated — a referral has one recipient thread, so the referral identifies the conversation.
     * @deprecated
     */
    receiver_facility_id?: string | null;
    /**
     * 
     */
    content: string;
    /**
     * 
     */
    system_event_type: MessageSystemEventTypeEnum | null;
    /**
     * 
     */
    system_event_data: object | null;
    /**
     * 
     */
    created_at: Date;
}


/**
 * @export
 */
export const MessageAuthorTypeEnum = {
    ReferralSender: 'referral_sender',
    ReferralParticipant: 'referral_participant',
    System: 'system',
} as const;
export type MessageAuthorTypeEnum = typeof MessageAuthorTypeEnum[keyof typeof MessageAuthorTypeEnum];

/**
 * @export
 */
export const MessageMessageTypeEnum = {
    User: 'user',
    System: 'system',
} as const;
export type MessageMessageTypeEnum = typeof MessageMessageTypeEnum[keyof typeof MessageMessageTypeEnum];

/**
 * @export
 */
export const MessageSystemEventTypeEnum = {
    StatusChange: 'status_change',
    RecipientStatusChange: 'recipient_status_change',
    DocumentAdded: 'document_added',
    DateChanged: 'date_changed',
} as const;
export type MessageSystemEventTypeEnum = typeof MessageSystemEventTypeEnum[keyof typeof MessageSystemEventTypeEnum];


/**
 * Check if a given object implements the Message interface.
 */
export function instanceOfMessage(value: object): value is Message {
    if (!('message_id' in value) || value['message_id'] === undefined) return false;
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('author_type' in value) || value['author_type'] === undefined) return false;
    if (!('message_type' in value) || value['message_type'] === undefined) return false;
    if (!('sender_user_id' in value) || value['sender_user_id'] === undefined) return false;
    if (!('sender_facility_id' in value) || value['sender_facility_id'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('system_event_type' in value) || value['system_event_type'] === undefined) return false;
    if (!('system_event_data' in value) || value['system_event_data'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function MessageFromJSON(json: any): Message {
    return MessageFromJSONTyped(json, false);
}

export function MessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Message {
    if (json == null) {
        return json;
    }
    return {
        
        'message_id': json['message_id'],
        'referral_id': json['referral_id'],
        'author_type': json['author_type'],
        'author_participant_id': json['author_participant_id'] === undefined ? undefined : json['author_participant_id'] === null ? null : json['author_participant_id'],
        'author_user_id': json['author_user_id'] === undefined ? undefined : json['author_user_id'] === null ? null : json['author_user_id'],
        'message_type': json['message_type'],
        'sender_user_id': json['sender_user_id'],
        'sender_user_name': json['sender_user_name'] === undefined ? undefined : json['sender_user_name'] === null ? null : json['sender_user_name'],
        'sender_user_title': json['sender_user_title'] === undefined ? undefined : json['sender_user_title'] === null ? null : json['sender_user_title'],
        'sender_facility_id': json['sender_facility_id'],
        'receiver_facility_id': json['receiver_facility_id'] === undefined ? undefined : json['receiver_facility_id'] === null ? null : json['receiver_facility_id'],
        'content': json['content'],
        'system_event_type': json['system_event_type'],
        'system_event_data': json['system_event_data'],
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
    };
}

export function MessageToJSON(json: any): Message {
    return MessageToJSONTyped(json, false);
}

export function MessageToJSONTyped(value?: Message | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message_id': value['message_id'],
        'referral_id': value['referral_id'],
        'author_type': value['author_type'],
        'author_participant_id': value['author_participant_id'],
        'author_user_id': value['author_user_id'],
        'message_type': value['message_type'],
        'sender_user_id': value['sender_user_id'],
        'sender_user_name': value['sender_user_name'],
        'sender_user_title': value['sender_user_title'],
        'sender_facility_id': value['sender_facility_id'],
        'receiver_facility_id': value['receiver_facility_id'],
        'content': value['content'],
        'system_event_type': value['system_event_type'],
        'system_event_data': value['system_event_data'],
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
    };
}

